module.exports = __webpack_public_path__ + "img/coding-dark.f497e92f.svg";